import React, {
  Fragment, useState, useRef, useEffect,
} from 'react'

import { bool, string } from 'prop-types'

import EnterCodeModal from '../EnterCodeModal/EnterCodeModal'

function TriggerInSettings({
  authToken: initAuthToken = null,
  btnText,
  btnClass = 'cgt-button cgt-button--primary cgt-button--large',
  context,
  userIsAdmin,
}) {
  const submitButtonRef = useRef()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [authToken, setAuthToken] = useState(initAuthToken || '')

  function openModal() {
    setIsModalOpen(true)
  }

  useEffect(() => {
    if (authToken.length > 0 && authToken !== initAuthToken) {
      submitButtonRef.current.click()
    }
  }, [authToken])

  return (
    <Fragment>
      <input type="hidden" name="auth_token" value={authToken} />

      <button
        ref={submitButtonRef}
        type={authToken.length > 0 || userIsAdmin ? 'submit' : 'button'}
        className={btnClass}
        onClick={!userIsAdmin && authToken.length === 0 ? openModal : undefined}
      >
        <span>{btnText}</span>
      </button>

      {isModalOpen && (
        <EnterCodeModal
          setAuthToken={setAuthToken}
          closeModal={() => setIsModalOpen(false)}
          context={context}
        />
      )}
    </Fragment>
  )
}

TriggerInSettings.propTypes = {
  authToken: string,
  btnText: string.isRequired,
  btnClass: string,
  context: string.isRequired,
  userIsAdmin: bool.isRequired,
}

export default TriggerInSettings
